/* 商品詳細: バリエーション選択・在庫◯△×・ギャラリー・数量・お気に入り・カート投入（本番 shop-detail.html の挙動を移植） */
(function () {
  var P = window.DW_PRODUCT;
  if (!P) return;
  var LOW_STOCK = 3;
  /* 表示文言はセクション設定から受け取る（未設定なら従来の日本語） */
  var L = P.labels || {};
  function t(key, fallback) { return L[key] || fallback; }

  var optRows = Array.prototype.slice.call(document.querySelectorAll('.js-opt-row'));
  var selected = P.options.map(function (_, i) {
    var row = optRows[i];
    if (!row) return null;
    var cur = row.querySelector('.opt-btn.is-active') || row.querySelector('.opt-btn');
    return cur ? cur.getAttribute('data-value') : null;
  });

  /* 選んだバリアントを URL の ?variant= に反映（Shopify 標準と同じ。ZenLink 等は URL だけで SKU を特定する） */
  function setVariantUrl(id) {
    try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u.toString()); } catch (e) {}
  }

  function findVariant(sel) {
    return P.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
  }
  function stockMark(v) {
    if (!v) return '×';
    if (v.tracked && v.policy === 'deny') {
      if (v.qty <= 0) return '×';
      if (v.qty <= LOW_STOCK) return '△';
      return '◯';
    }
    return v.available ? '◯' : '×';
  }

  var priceEl = document.getElementById('js-price');
  var availEl = document.getElementById('js-availability');
  var mainImg = document.getElementById('gallery-main');
  var caption = document.getElementById('gallery-caption');
  var soldBadge = document.getElementById('js-detail-soldout');
  var vidInput = document.getElementById('js-variant-id');
  var addBtn = document.getElementById('js-addcart');
  var qtyRow = document.getElementById('js-qty-row');
  var stockBox = document.getElementById('js-stock');

  // 在庫◯△×（最後のオプション＝サイズを基準に、他オプションは選択値で固定）
  function renderStock() {
    if (!stockBox || !P.options.length) return;
    var lastIdx = P.options.length - 1;
    var lastOpt = P.options[lastIdx];
    var row = optRows[lastIdx];
    if (!row) { stockBox.style.display = 'none'; return; }
    var values = Array.prototype.slice.call(row.querySelectorAll('.opt-btn')).map(function (b) { return b.getAttribute('data-value'); });
    // 本番（denimworks.co.jp）と同じ見せ方にする:
    //   角丸の枠つきチップ／選択中のサイズは枠を濃くして背景を敷く／在庫なしは文字を薄く
    //   記号の色は ◯=緑 / △=赤 / ×=赤
    var html = '<span class="label" style="flex:0 0 auto;font-weight:700;letter-spacing:.06em;padding-top:4px;">' + t('stock', '在庫') + '</span>'
             + '<div style="display:flex;flex-wrap:wrap;gap:8px;">';
    values.forEach(function (val) {
      var sel = selected.slice();
      sel[lastIdx] = val;
      var v = findVariant(sel);
      var mark = stockMark(v);
      var color = mark === '◯' ? '#2e7d32' : '#c0392b';
      var isCur = selected[lastIdx] === val;
      var chip = isCur ? 'border-color:#1a1815;background:#f7f5f2;' : 'border-color:var(--c-line);';
      var dim = mark === '×' ? 'color:var(--c-text-subtle);' : '';
      html += '<span style="display:inline-flex;align-items:center;gap:4px;padding:4px 14px;border:1px solid;border-radius:999px;'
            + chip + dim + '">' + val + ' <span style="color:' + color + ';font-weight:700;">' + mark + '</span></span>';
    });
    html += '</div>';
    stockBox.innerHTML = html;
    stockBox.style.display = 'flex';
  }

  function update() {
    var v = findVariant(selected);
    if (!v) v = P.variants.find(function (x) { return x.available; }) || P.variants[0];
    if (priceEl) priceEl.textContent = v.price;
    if (vidInput) vidInput.value = v.id;
    if (v.image && mainImg) { mainImg.src = v.image; }
    var sold = P.soldTag || !v.available;
    if (soldBadge) soldBadge.style.display = sold ? 'block' : 'none';
    if (addBtn) {
      addBtn.disabled = sold;
      // 海外判定時（html.is-zl・zenlink-spec.js）は国内配送のみの旨の文言にする
      var zlLabel = document.documentElement.classList.contains('is-zl') && addBtn.getAttribute('data-zl-label');
      addBtn.textContent = sold ? t('soldOut', 'SOLD OUT') : (zlLabel || t('addToCart', 'カートに入れる'));
    }
    if (qtyRow) qtyRow.style.display = sold ? 'none' : '';
    if (availEl) {
      if (sold) { availEl.textContent = t('outOfStock', '在庫なし'); availEl.style.color = '#c0392b'; }
      else if (v.tracked && v.policy === 'deny' && v.qty > 0 && v.qty <= LOW_STOCK) { availEl.textContent = t('lowStock', '残りわずか'); availEl.style.color = '#c07b00'; }
      else { availEl.textContent = t('inStock', '在庫あり'); availEl.style.color = '#1f7a3d'; }
    }
    renderStock();
  }

  // オプション選択
  optRows.forEach(function (row, i) {
    row.querySelectorAll('.opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        row.querySelectorAll('.opt-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[i] = btn.getAttribute('data-value');
        update();
        if (vidInput && vidInput.value) setVariantUrl(vidInput.value);
      });
    });
  });

  // ギャラリー
  document.querySelectorAll('.js-gallery-thumbs .thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.js-gallery-thumbs .thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      if (mainImg) mainImg.src = t.getAttribute('data-src');
      if (caption) {
        var cap = (t.getAttribute('data-caption') || '').trim();
        caption.textContent = cap;
        caption.style.display = cap ? 'block' : 'none';
      }
    });
  });

  // 数量 → hidden input
  var qtySel = document.getElementById('js-qty');
  var qtyInput = document.getElementById('js-qty-input');
  if (qtySel && qtyInput) qtySel.addEventListener('change', function () { qtyInput.value = qtySel.value; });

  // カート投入（裾上げを line item プロパティで付与、Ajax→カートへ）
  var form = document.getElementById('js-add-form');
  var hemSel = document.getElementById('js-hem');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var body = { id: vidInput.value, quantity: parseInt((qtyInput && qtyInput.value) || '1', 10) };
      if (hemSel && hemSel.value && hemSel.value !== '裾上げなし') {
        body.properties = { '裾上げ': hemSel.value };
      }
      // 英語版では /en が付く。window.Shopify.routes.root から組み立てる
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function () {
        location.href = root + 'cart';
      }).catch(function () { form.submit(); });
    });
  }

  // お気に入り（localStorage）
  var favBtn = document.getElementById('js-fav');
  var KEY = 'DWWish';
  function getWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function setWish(a) { localStorage.setItem(KEY, JSON.stringify(a)); }
  if (favBtn) {
    var label = favBtn.querySelector('.js-fav-label');
    var h = favBtn.getAttribute('data-handle');
    function sync() {
      var on = getWish().indexOf(h) >= 0;
      favBtn.classList.toggle('is-active', on);
      if (label) label.textContent = on ? t('favAdded', 'お気に入り登録済み') : t('favAdd', 'お気に入りに追加');
    }
    favBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var w = getWish(); var idx = w.indexOf(h);
      if (idx >= 0) w.splice(idx, 1); else w.push(h);
      setWish(w); sync();
    });
    sync();
  }

  update();
})();
